import React, { Children } from 'react'

import './style.scss'

const Card = ({ children, className, onClick }: any) => {
  return (
    <div className={`shadow-card ${className}`} onClick={onClick}>
      {Children.toArray(children)}
    </div>
  )
}

export default Card
